import { render, staticRenderFns } from "./PromotionsChannelPositioning.vue?vue&type=template&id=2ade0368&scoped=true&"
import script from "./PromotionsChannelPositioning.vue?vue&type=script&lang=ts&"
export * from "./PromotionsChannelPositioning.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionsChannelPositioning.vue?vue&type=style&index=0&id=2ade0368&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade0368",
  null
  
)

export default component.exports